import React from 'react';

const RadioButtonUI = (props) => {
    return (
        <div>
            {props.label === undefined ? <></> : 
            <>
                <span className={props.required ? 'sixth-text-color required' : 'sixth-text-color'}>
                    {props.label}
                </span>
                <br />
            </>}
            <div style={{ marginTop: '7px' }}>
                {props.items?.map((item) => (
                    <label style={{ marginRight: '10px' }} key={`${item.id}`}>
                        <input
                            name={props.name}
                            id={item.id}
                            type="radio"
                            onChange={(e) => props.onChange(e)}
                            className="with-gap"
                            value={item.id}
                            checked={item.id === props.defaultChecked}
                            {...props}
                        />
                        <span
                            className={props.className}
                            style={{ paddingLeft: '25px' }}
                        >
                            {item.label}
                        </span> <br />
                    </label>
                ))}
            </div>
        </div>
    );
};

export default (RadioButtonUI);
